/* eslint-disable camelcase */
import { paymentTypes } from 'tools/payment'

export const paymentResultsPath = '/callback/payment'

export const makeQueryString = (obj) => {
  const query = Object.keys(obj).map((param) => obj[param] && `${param}=${obj[param]}`).join('&')
  return query ? `?${query}` : ''
}

export function create (express) {
  const router = new express.Router()

  router.get(`${paymentResultsPath}/checkout/:storeOrderId`, (req, res) => {
    const { storeOrderId } = req.params
    const { error, locale, payment_method, ...rest } = req.query || {}
    const paymentMethod = parseInt(payment_method)
    if (error || paymentMethod === paymentTypes.stripe || paymentMethod === paymentTypes.stripeExpressAccount) {
      res.redirect(`/${locale}/checkout/${storeOrderId}${makeQueryString({ ...rest, payment_method, error })}`)
    } else {
      res.redirect(`/${locale}/thankyou${makeQueryString({ ...rest, storeOrderId })}`)
    }
  })

  router.get(`${paymentResultsPath}/invoice/:storeOrderId/:hashCode`, (req, res) => {
    const { storeOrderId, hashCode } = req.params
    const { error, locale, payment_method, ...rest } = req.query || {}
    const paymentMethod = parseInt(payment_method)
    if (error || paymentMethod === paymentTypes.stripe || paymentMethod === paymentTypes.stripeExpressAccount) {
      res.redirect(`/${locale}/invoice/${storeOrderId}/${hashCode}${makeQueryString({ ...rest, payment_method, error })}`)
    } else {
      res.redirect(`/${locale}/thankyou${makeQueryString({ ...rest, storeOrderId })}`)
    }
  })

  return ['', router]
}
